module.exports = __webpack_public_path__ + "assets/bg-891f251d.png";